@use '../../scss/utility';

$header-height-small: 80px;
$header-height-large: 96px;

$desktop-nav-bar-height: 56px;

$desktop-upper-header-total-height: $header-height-large + $desktop-nav-bar-height;

:host {
  /** @prop --z-index: z-index of the component */
  --z-index: #{utility.$z-index-header-flyout};

  position: fixed;
  width: 100%;
  inset-block-end: 0;
  z-index: var(--z-index);

  @include utility.breakpoint-from(mq3) {
    height: calc(100% - #{$header-height-large});
    display: none;
  }

  @include utility.breakpoint-from(mq5) {
    height: calc(100% - #{$desktop-upper-header-total-height}); //( upper part + main nav)
  }
}

:host([open]) {
  display: block;
}

.close-layer {
  position: fixed;
  width: 100%;
  inset-block-end: 0;
  display: none;

  background: rgba(0, 0, 0, 0.8);

  @include utility.breakpoint-from(mq3) {
    display: block;
    height: calc(100% - #{$header-height-small});
  }

  @include utility.breakpoint-from(mq5) {
    height: calc(100% - #{$desktop-upper-header-total-height}); // upper part + main nav
  }
}

.inner {
  height: 100%;

  @include utility.breakpoint-from(mq3) {
    width: var(--wb-grid-width);
    margin-inline-start: auto;
    margin-inline-end: auto;
    position: relative;
  }
}
